import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44ad189c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "air" }
const _hoisted_2 = { class: "air-top" }
const _hoisted_3 = { class: "air-desc" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "air-title" }, "空调", -1))
const _hoisted_5 = { class: "air-temperature" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "air-status"
}
const _hoisted_8 = {
  key: 1,
  class: "air-loading"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "air-right" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "air-control"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control-title" }, "温度调节", -1))
const _hoisted_14 = { class: "btn-box" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "air-control"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control-title" }, "风量调节", -1))
const _hoisted_19 = { class: "btn-box" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "air-dialog-content" }
const _hoisted_23 = { class: "dialog-top" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "dialog-text" }
const _hoisted_26 = { class: "air-body-item-num" }
const _hoisted_27 = {
  key: 0,
  class: "air-temp-num"
}
const _hoisted_28 = {
  key: 1,
  class: "air-temp-load"
}
const _hoisted_29 = {
  key: 0,
  class: "air-notice"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确定", -1))
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.airData.tempSet ? _ctx.airData.tempSet : "") + " ", 1),
          (_ctx.airData.tempSet)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_6, "℃"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.hasAir)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.airData.isOpen ? "空调已开启" : "空调已关闭"), 1))
          : _createCommentVNode("", true),
        (_ctx.airData.isOpen)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              (_ctx.airData.icon == 1 || _ctx.airData.icon == 2 || _ctx.airData.icon == 3)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.airRunImg,
                    alt: ""
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.airData.spaceStatus), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.airData.airImg)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.airData.airImg,
              alt: ""
            }, null, 8, _hoisted_11))
          : (_openBlock(), _createBlock(_component_van_loading, {
              key: 1,
              style: {"padding-top":"20px"}
            })),
        (_ctx.hasAir)
          ? (_openBlock(), _createBlock(_component_Switch, {
              key: 2,
              class: "switch-btn",
              loading: _ctx.loadingAir || _ctx.firstLoadingAir,
              disabled: !_ctx.userIsControl || _ctx.loadingAir || _ctx.firstLoadingAir,
              "inactive-color": "rgba(196, 196, 196, 0.4)",
              onClick: _ctx.airChange,
              "model-value": _ctx.airData.isOpen
            }, null, 8, ["loading", "disabled", "onClick", "model-value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.userIsControl && _ctx.airData.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "control-btn mr20",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changeAir(4, 'temp', 'toCold')), ["stop"]))
            }, [
              _createElementVNode("img", {
                src: _ctx.parseImgUrl('envmonitor', 'arrow-top.png'),
                alt: ""
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("div", {
              class: "control-btn",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changeAir(2, 'temp', 'toWarm')), ["stop"]))
            }, [
              _createElementVNode("img", {
                src: _ctx.parseImgUrl('envmonitor', 'arrow-down.png'),
                alt: ""
              }, null, 8, _hoisted_16)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userIsControl && _ctx.airData.isOpen && _ctx.showAirVolumeBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "control-btn mr20",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.changeAir(5, 'wind', 'toWindLow')), ["stop"]))
            }, [
              _createElementVNode("img", {
                class: "temp-img",
                src: _ctx.parseImgUrl('envmonitor', 'fengshan.png'),
                alt: ""
              }, null, 8, _hoisted_20)
            ]),
            _createElementVNode("div", {
              class: "control-btn",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.changeAir(6, 'wind', 'toWindUp')), ["stop"]))
            }, [
              _createElementVNode("img", {
                class: "temp-img",
                src: _ctx.parseImgUrl('envmonitor', 'wendu.png'),
                alt: ""
              }, null, 8, _hoisted_21)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_dialog, {
      show: _ctx.showDialog,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDialog) = $event)),
      class: "dialog-width",
      "show-confirm-button": false,
      "show-cancel-button": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("img", {
              class: _normalizeClass(["img-greey", 
              _ctx.airSetText.toWhere == 'toCold'
                ? 'img-blue'
                : _ctx.airSetText.toWhere == 'toWarm'
                ? 'img-red'
                : ''
            ]),
              src: _ctx.parseImgUrl('page-officehome', _ctx.airSetText.nowImg),
              alt: ""
            }, null, 10, _hoisted_24)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              (_ctx.airSetText.notice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.airSetText.notice), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_van_loading, { type: "spinner" })
                  ]))
            ]),
            (_ctx.airSetText.remark && _ctx.airSetText.remark.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.airSetText.remark, (remarkItem, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: 'remark' + index
                    }, _toDisplayString(remarkItem), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "dialog-btns",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["stop"]))
          }, _hoisted_31)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}